/* SQINWEAR · Portada, bloque Top ventas.
   - Móvil: cuadrícula de 2 en 2. El carrusel del tema (Swiper) bloquea el deslizamiento horizontal dentro de cada tarjeta,
     así que se apaga para que se puedan pasar las fotos de cada producto con el dedo.
   - Ordenador (990 px o más): se queda el carrusel, con 4 productos por fila. */
(function(){
  function run(){
    var desk = window.innerWidth >= 990;
    document.querySelectorAll('.section--featured-products .card-product-slider').forEach(function(el){
      var s = el.swiper;
      if (!desk){
        if (s && !s.destroyed) { s.destroy(true, true); }
        el.style.touchAction = 'auto';
        return;
      }
      if (s && !s.destroyed && !el.dataset.sq4){
        el.dataset.sq4 = '1';
        var bp = s.params.breakpoints || {};
        Object.keys(bp).forEach(function(k){ bp[k].slidesPerView = 4; });
        s.params.slidesPerView = 4;
        s.currentBreakpoint = null;
        try { s.setBreakpoint(); } catch(e){}
        s.update();
      }
    });
  }
  var n = 0, t = setInterval(function(){ run(); if (++n > 24) clearInterval(t); }, 250);
  window.addEventListener('load', run);
  var r; window.addEventListener('resize', function(){ clearTimeout(r); r = setTimeout(run, 300); });
})();
